import * as React from 'react';
import { useRoutes } from "react-router-dom";
import Home from '../pages/home/Home';
import PageNotFound from '../pages/error/PageNotFound'
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';

export default function Router() {
  return useRoutes([{ path: '/', element: <Home /> }, MainRoutes, AuthenticationRoutes, { path: '*', element: <PageNotFound /> }])
}